/**
 * @voltxampere/ui — 32.768 kHz watch crystal (Sprint 45-6, placeholder)
 *
 * PLACEHOLDER. Watch / RTC zaman tutucu kristal — düşük frekans,
 * yüksek hassasiyet (±20 ppm typical). 32768 Hz = 2^15 Hz, RTC
 * 1 Hz binary divide.
 *
 * Reference: Generic 32.768 kHz watch crystal — Abracon ABS25 / Epson
 * FC-12M, tuning fork, ±20 ppm @ 25°C, C_L = 12.5 pF. RTC
 * (DS1307, DS3231 + harici), kol saatı, accurate timekeeping.
 *
 *   Default mapping → inductor schemaType:
 *     inductance = 100e-3  (100 mH placeholder, low-freq tuning fork)
 *
 * Engine zero-diff invariant honored — canonical `inductor` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { inductor } from "../inductor.js";
export const crystal32k768 = {
    id: "crystal-32k768",
    nameTr: "Kristal 32.768 kHz (Watch, RTC, placeholder)",
    nameEn: "Crystal 32.768 kHz (Watch, RTC, placeholder)",
    shortcut: "L",
    category: "passive",
    viewBox: inductor.viewBox,
    terminals: inductor.terminals,
    defaultLabel: "Y",
    defaultValue: "32.768kHz",
    schemaType: "inductor",
    defaultParams: { inductance: 100e-3 },
    renderSVG: () => inductor.renderSVG(),
};
//# sourceMappingURL=crystal-32k768.js.map